import { j as e } from "./jsx-runtime-3tyXYecC.mjs";
import { F as a } from "./flex-Cc3osQLf.mjs";
import { L as l } from "./layout-box-DFBM-kSI.mjs";
import { P as K, a as M } from "./pill-DHjByxtv.mjs";
import { isValidElement as y } from "react";
import { D as b } from "./divider-Dq5lrAFK.mjs";
import { H as E } from "./headline-DF2GOgMa.mjs";
import { B as N } from "./body-text-BiQwh5-U.mjs";
import { L as Q } from "./link-0A1muLDU.mjs";
function j({ size: n = "extra-large", ...t }) {
  return /* @__PURE__ */ e.jsx(E, { component: "h1", size: n, ...t });
}
function h({ size: n = "medium", ...t }) {
  return /* @__PURE__ */ e.jsx(E, { color: "neutral-weak", component: "h2", size: n, ...t });
}
function F({
  children: n,
  icon: t = "angle-left-regular",
  ...f
}) {
  return /* @__PURE__ */ e.jsx(Q, { color: "muted", ...f, children: /* @__PURE__ */ e.jsx(N, { icon: t, size: "extra-small", children: n }) });
}
const o = (n) => y(n) ? n : (n == null ? void 0 : n.content) || null, d = (n) => y(n) ? {} : (n == null ? void 0 : n.options) || {};
function c({
  breadcrumb: n,
  description: t,
  divider: f,
  id: G,
  primaryContent: i,
  secondaryContent: s,
  status: p,
  subtitle: u,
  tabs: r,
  tertiaryContent: g,
  title: x
}) {
  var P, S, T, H, w, V, D, v, L, k;
  const m = s || g ? "tertiary" : "primary", z = r ? !1 : f, B = typeof x == "string" ? /* @__PURE__ */ e.jsx(j, { children: x }) : x, I = typeof u == "string" ? /* @__PURE__ */ e.jsx(h, { children: u }) : u, O = typeof p == "string" ? /* @__PURE__ */ e.jsx(a, { alignSelf: "center", children: /* @__PURE__ */ e.jsx(K, { type: M.Brand, children: p }) }) : p, R = n && /* @__PURE__ */ e.jsx(a, { paddingBottom: (P = d(n)) != null && P.noPadding ? 0 : 2, children: o(n) }), W = B && /* @__PURE__ */ e.jsxs(a, { flexDirection: "column", flexGrow: 1, gap: 1.5, paddingBottom: (S = d(x)) != null && S.noPadding ? 0 : 2, children: [
    /* @__PURE__ */ e.jsxs(a, { alignItems: "baseline", columnGap: 3, flexDirection: "row", flexWrap: "wrap", children: [
      o(B),
      O
    ] }),
    I,
    t
  ] }), q = m === "primary" ? (i || r) && /* @__PURE__ */ e.jsxs(a, { alignSelf: i ? void 0 : "end", flexDirection: "column", justifyContent: "space-between", children: [
    i && /* @__PURE__ */ e.jsx(
      l,
      {
        alignSelf: "end",
        paddingBottom: (T = d(i)) != null && T.noPadding ? 0 : 3,
        paddingTop: (H = d(i)) != null && H.noPadding ? 0 : 0.5,
        children: o(i)
      }
    ),
    r && /* @__PURE__ */ e.jsx(l, { alignSelf: "end", marginBottom: "-1px", children: o(r) })
  ] }) : i && /* @__PURE__ */ e.jsx(
    l,
    {
      paddingBottom: (w = d(i)) != null && w.noPadding ? 0 : 3,
      paddingTop: (V = d(i)) != null && V.noPadding ? 0 : 0.5,
      children: o(i)
    }
  ), A = s ? /* @__PURE__ */ e.jsx(
    l,
    {
      paddingBottom: (D = d(s)) != null && D.noPadding ? 0 : 2,
      paddingTop: (v = d(s)) != null && v.noPadding ? 0 : 2,
      children: o(s)
    }
  ) : (
    // Show an empty div so that anything else on the secondary row is pushed to the right.
    /* @__PURE__ */ e.jsx("div", {})
  ), J = r && m === "tertiary" ? /* @__PURE__ */ e.jsx(l, { alignSelf: "end", marginBottom: "-1px", children: o(r) }) : g && /* @__PURE__ */ e.jsx(
    l,
    {
      paddingBottom: (L = d(g)) != null && L.noPadding ? 0 : 2,
      paddingTop: (k = d(g)) != null && k.noPadding ? 0 : 2,
      children: o(g)
    }
  );
  return /* @__PURE__ */ e.jsxs(a, { "data-fabric-component": "PageHeaderV2", flexDirection: "column", id: G, children: [
    R,
    /* @__PURE__ */ e.jsxs(a, { gap: 2.5, justifyContent: "space-between", children: [
      W,
      q
    ] }),
    (z || r && m === "primary") && /* @__PURE__ */ e.jsx(b, { color: "neutral-weak" }),
    /* @__PURE__ */ e.jsxs(a, { gap: 2.5, justifyContent: "space-between", children: [
      A,
      J
    ] }),
    r && m === "tertiary" && /* @__PURE__ */ e.jsx(b, { color: "neutral-weak" })
  ] });
}
c.PageHeaderV2Title = j;
c.PageHeaderV2Subtitle = h;
c.PageHeaderV2Breadcrumb = F;
c.Title = j;
c.Subtitle = h;
c.Breadcrumb = F;
export {
  c as P
};
//# sourceMappingURL=page-header-v2-euFeEHtr.mjs.map
